import React from "react";
import { Field, ErrorMessage } from "formik";
import { Form as BootstrapForm } from "react-bootstrap";
const InputField = ({ label, name, type, placeholder }) => {
    return (
        <BootstrapForm.Group className="mb-3">
            {label !== "no" && <BootstrapForm.Label>{label}</BootstrapForm.Label>}
            <Field name={name} type={type} className="form-control" placeholder={placeholder} />
            <ErrorMessage name={name} component="div" className="text-danger small" />
        </BootstrapForm.Group>
    );
};

export default InputField;
